var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _vm.stores && _vm.selectedStore
      ? _c("div", [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Склад")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedStore,
                            expression: "selectedStore",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedStore = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.getStores(false)
                            },
                          ],
                        },
                      },
                      _vm._l(_vm.stores, function (store, index) {
                        return _c("option", { domProps: { value: store } }, [
                          _vm._v(
                            _vm._s(store.title) + " (" + _vm._s(store.id) + ")"
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Название")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedStore.title,
                          expression: "selectedStore.title",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.selectedStore.title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.selectedStore,
                            "title",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-2" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Сокращение")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedStore.short_title,
                          expression: "selectedStore.short_title",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.selectedStore.short_title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.selectedStore,
                            "short_title",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Адрес")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedStore.address,
                          expression: "selectedStore.address",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.selectedStore.address },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.selectedStore,
                            "address",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-check" }, [
                _c("label", { staticClass: "form-check-label pointer" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedStore.is_active,
                        expression: "selectedStore.is_active",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.selectedStore.is_active)
                        ? _vm._i(_vm.selectedStore.is_active, null) > -1
                        : _vm.selectedStore.is_active,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.selectedStore.is_active,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.selectedStore,
                                "is_active",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.selectedStore,
                                "is_active",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.selectedStore, "is_active", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" Склад активен\n          "),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "flex flex-wrap" },
                _vm._l(_vm.stores, function (store, index) {
                  return store.is_active && store.id !== _vm.selectedStore.id
                    ? _c(
                        "div",
                        { staticClass: "store_directions" },
                        [
                          _vm.allowedToReceiveFrom[store.id]
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-primary" },
                                  [_vm._v(_vm._s(store.title))]
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(store.title) +
                                    "\n            "
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm._e()
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _vm.allowedToSend
              ? _c("div", { staticClass: "card-body" }, [
                  _c("div", {}, [
                    _c("table", { staticClass: "table table-sm table-hover" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(
                          _vm.sortRecords(_vm.stores, "title"),
                          function (store, index) {
                            return store.is_active &&
                              store.id !== 4 &&
                              store.id !== _vm.selectedStore.id
                              ? _c("tr", [
                                  _c("td", [
                                    _c("div", { staticClass: "form-check" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "form-check-label pointer",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.allowedToSend[store.id]
                                                    .active,
                                                expression:
                                                  "allowedToSend[store.id].active",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.allowedToSend[store.id]
                                                  .active
                                              )
                                                ? _vm._i(
                                                    _vm.allowedToSend[store.id]
                                                      .active,
                                                    null
                                                  ) > -1
                                                : _vm.allowedToSend[store.id]
                                                    .active,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.allowedToSend[store.id]
                                                      .active,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.allowedToSend[
                                                          store.id
                                                        ],
                                                        "active",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.allowedToSend[
                                                          store.id
                                                        ],
                                                        "active",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.allowedToSend[store.id],
                                                    "active",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(store.title) +
                                              " (" +
                                              _vm._s(store.id) +
                                              ")\n                  "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.allowedToSend[store.id].days,
                                            expression:
                                              "allowedToSend[store.id].days",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.allowedToSend[store.id],
                                              "days",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "0", disabled: "" },
                                          },
                                          [_vm._v("не указан")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(15, function (i) {
                                          return _c(
                                            "option",
                                            { domProps: { value: i + 1 } },
                                            [_vm._v(_vm._s(i + 1))]
                                          )
                                        }),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.allowedToSend[store.id].time,
                                            expression:
                                              "allowedToSend[store.id].time",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.allowedToSend[store.id],
                                              "time",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      _vm._l(24, function (index) {
                                        return _c(
                                          "option",
                                          {
                                            domProps: {
                                              value: `${(
                                                "0" +
                                                (index - 1)
                                              ).slice(-2)}:00`,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  ("0" + (index - 1)).slice(-2)
                                                ) +
                                                ":00\n                  "
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-default btn-xs",
                                        on: {
                                          click: function ($event) {
                                            return _vm.addSendSchedule(store.id)
                                          },
                                        },
                                      },
                                      [_vm._v("Добавить отправку")]
                                    ),
                                    _vm._v(" "),
                                    _vm.sendSchedule[store.id] &&
                                    _vm.sendSchedule[store.id].length
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.sendSchedule[store.id],
                                            function (s, i) {
                                              return _c(
                                                "div",
                                                { staticClass: "input-group" },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: s.dayOfWeek,
                                                          expression:
                                                            "s.dayOfWeek",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            s,
                                                            "dayOfWeek",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.daysOfWeek,
                                                      function (d) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: d.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(d.title)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-append",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-outline-danger",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeSendSchedule(
                                                                store.id,
                                                                i
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "icon-fa icon-fa-trash",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ]),
                                ])
                              : _vm._e()
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", [
                _c("div", { staticClass: "form-check" }, [
                  _c("label", { staticClass: "form-check-label pointer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.allowedToReceiveInvoiceIncome,
                          expression: "allowedToReceiveInvoiceIncome",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.allowedToReceiveInvoiceIncome
                        )
                          ? _vm._i(_vm.allowedToReceiveInvoiceIncome, null) > -1
                          : _vm.allowedToReceiveInvoiceIncome,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.allowedToReceiveInvoiceIncome,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.allowedToReceiveInvoiceIncome = $$a.concat(
                                  [$$v]
                                ))
                            } else {
                              $$i > -1 &&
                                (_vm.allowedToReceiveInvoiceIncome = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.allowedToReceiveInvoiceIncome = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(
                      " Допустимо\n              поступление препаратов извне от поставщиков (создавать накладные поступления)\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(
                          "Количество дней для просчета (потенциально) проблемных заявок"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.daysForConflictsOrders,
                            expression: "daysForConflictsOrders",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.daysForConflictsOrders },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.daysForConflictsOrders = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "vue-ladda",
                {
                  attrs: {
                    "button-class": "btn btn-success btn-sm",
                    "data-style": "zoom-in",
                    loading: _vm.updateStoreDataLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.saveStoreData()
                    },
                  },
                },
                [_vm._v("Сохранить\n      ")]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Настройка складов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Допустимы перемещения со складов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Допустимые перемещения на склады")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Склад")]),
        _vm._v(" "),
        _c("th", [_vm._v("Срок по умолчанию (дней) не считая текущего")]),
        _vm._v(" "),
        _c("th", [_vm._v("Время")]),
        _vm._v(" "),
        _c("th", [_vm._v("Отправка")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }